import React from 'react';
import PropTypes from 'prop-types';
import ProbabilitiesPopover from './ProbabilitiesPopover';
import { CROSSTAB_PROBABILITIES_NA_CONSTANT } from '../../../constants';

const DefaultIndexCell = ({ title, className, value, height, crosstabviewFlag,
   rowData, colData, handleProbabilitiesEditClick }) => {
  const style = {};

  if (crosstabviewFlag) {
    style.height = height;
  }
  if (value === CROSSTAB_PROBABILITIES_NA_CONSTANT) {
    return (
      <ProbabilitiesPopover
        value={value}
        rowData={rowData}
        colData={colData}
        crosstabviewFlag={crosstabviewFlag}
        handleProbabilitiesEditClick={handleProbabilitiesEditClick}
      />
    );
  }
  return (
    <div title={title} className={className} style={style}>{value}</div>
  );
};

DefaultIndexCell.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  rowData: PropTypes.Object,
  colData: PropTypes.Object,
  handleProbabilitiesEditClick: PropTypes.func,
};

export default DefaultIndexCell;
